import { render, staticRenderFns } from "./MessageManage.vue?vue&type=template&id=0cad2761&scoped=true"
import script from "./MessageManage.vue?vue&type=script&lang=js"
export * from "./MessageManage.vue?vue&type=script&lang=js"
import style0 from "./MessageManage.vue?vue&type=style&index=0&id=0cad2761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad2761",
  null
  
)

export default component.exports